(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["jimmy-hero"] && !Shopify.designMode) return;
  try {
    
/* Jimmy That! seasoning hero — dishes slide in, the jar shakes, real flakes land on the food. */
(() => {
  if (window.customElements.get('jimmy-hero')) return;

  const TAU = Math.PI * 2;
  const DEG = Math.PI / 180;
  const clamp = (v, a, b) => (v < a ? a : v > b ? b : v);
  const lerp = (a, b, t) => a + (b - a) * t;
  const rand = (a, b) => a + Math.random() * (b - a);
  const inOut = (t) => (t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2);
  const outBack = (t, s = 1.4) => 1 + (s + 1) * Math.pow(t - 1, 3) + s * Math.pow(t - 1, 2);
  const lerpPose = (a, b, t) => ({ x: lerp(a.x, b.x, t), y: lerp(a.y, b.y, t), a: lerp(a.a, b.a, t) });

  // Timeline, in seconds from the moment a dish starts sliding in.
  const T = { exit: 0.3, windup: 0.05, enterDelay: 0.17, enterDur: 0.44, tilt0: 0.7, tilt1: 1.02, flick: 0.22, flicks: 5, back: 0.45 };
  T.enter = T.enterDelay + T.enterDur;
  T.shake1 = T.tilt1 + T.flick * T.flicks;
  T.back1 = T.shake1 + T.back;

  // Where the shaker holes sit on the jar image (fraction of height from its centre).
  const HOLES = 0.37;
  // The flakes image is an 8 x 8 grid of individual flakes.
  const FLAKE_GRID = 8;
  const DUST = ['#f3e5bb', '#ecd496', '#f8efd6', '#dcb873', '#f3e5bb', '#ecd496', '#8c9b3d', '#b9341f', '#3a2a1f'];

  class JimmyHero extends HTMLElement {
    connectedCallback() {
      if (this._live) return;
      this._live = true;
      requestAnimationFrame(() => this.setup());
    }

    disconnectedCallback() {
      this._live = false;
      window.removeEventListener('load', this.onLoad);
      cancelAnimationFrame(this.raf);
      this.raf = 0;
      this.ro && this.ro.disconnect();
      this.io && this.io.disconnect();
      document.removeEventListener('visibilitychange', this.onVis);
      document.removeEventListener('shopify:block:select', this.onBlockSelect);
      document.removeEventListener('shopify:block:deselect', this.onBlockDeselect);
    }

    setup() {
      if (!this._live) return;
      const q = (s) => this.querySelector(s);
      this.stage = q('[data-jh-stage]');
      this.canvas = q('[data-jh-fx]');
      this.jarEl = q('[data-jh-jar]');
      this.wordText = q('[data-jh-word-text]');
      this.squigglePath = q('[data-jh-squiggle] path');
      this.dishes = [...this.querySelectorAll('[data-jh-dish]')].map((el, i) => ({
        el, i,
        name: el.dataset.name || '',
        blockId: el.dataset.blockId || '',
        aspect: parseFloat(el.dataset.aspect) || 1.5,
        size: (parseFloat(el.dataset.size) || 100) / 100,
        sw: (parseFloat(el.dataset.spreadW) || 100) / 100,
        sx: (parseFloat(el.dataset.spreadX) || 0) / 100,
        sy: (parseFloat(el.dataset.spreadY) || 0) / 100,
        stuck: [],
        shown: false,
        shadowEl: el.querySelector('.jh__dish-shadow'),
        requested: false,
        ready: false,
        mask: undefined
      }));
      this.N = this.dishes.length;
      if (!this.stage || !this.canvas || !this.N) return;

      this.ctx = this.canvas.getContext('2d');
      this.period = Math.max(T.back1 + 0.5, parseFloat(this.dataset.period) || 4);
      this.density = (parseFloat(this.dataset.density) || 100) / 100;
      this.jarAspect = this.jarEl ? parseFloat(this.jarEl.dataset.aspect) || 0.425 : 0.425;
      this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.atlas = null; // until the flakes image loads, only fine dust is drawn
      this.particles = [];
      this.trickle = 0;
      this.playing = !this.reduced;
      this.visible = true;
      this.cur = 0;
      this.prev = -1;
      this.cycleT = 0;
      this.clock = 0;
      this.jarIntro = this.reduced ? 1 : 0;
      this.jarBlend = null;
      this.queued = null;
      this.wait = 0;

      this.classList.add('is-live');

      const src = this.dataset.flakes;
      if (src) {
        const img = new Image();
        img.decoding = 'async';
        img.onload = () => {
          this.atlas = { img, cols: FLAKE_GRID, cell: img.naturalWidth / FLAKE_GRID, count: FLAKE_GRID * FLAKE_GRID };
          if (this.reduced) this.prefill(this.dishes[this.cur]);
          this.render();
        };
        img.src = src;
      }

      this.ro = new ResizeObserver(() => this.layout());
      this.ro.observe(this.stage);
      this.io = new IntersectionObserver((entries) => {
        this.visible = entries[entries.length - 1].isIntersecting;
        this.kick();
      }, { threshold: 0.02 });
      this.io.observe(this.stage);
      this.onVis = () => this.kick();
      document.addEventListener('visibilitychange', this.onVis);

      // Theme editor: selecting a dish block shows that dish and holds it.
      this.onBlockSelect = (e) => {
        const d = this.dishes.find((x) => x.blockId && x.blockId === (e.detail && e.detail.blockId));
        if (!d) return;
        this.editorHold = true;
        this.load(d);
        this.jump(d.i);
        this.setPlaying(false);
      };
      this.onBlockDeselect = () => {
        if (!this.editorHold) return;
        this.editorHold = false;
        if (!this.reduced) this.setPlaying(true);
      };
      document.addEventListener('shopify:block:select', this.onBlockSelect);
      document.addEventListener('shopify:block:deselect', this.onBlockDeselect);

      this.layout();
      this.setWord(this.dishes[this.cur].name, true);
      // The first dish is already on the page. Fetch the second once the page has finished loading.
      this.load(this.dishes[0]);
      if (!this.reduced) {
        this.onLoad = () => this.load(this.dishes[1 % this.N]);
        if (document.readyState === 'complete') this.onLoad();
        else window.addEventListener('load', this.onLoad, { once: true });
      }
      if (this.reduced) {
        this.cycleT = T.back1 + 0.1;
        this.prefill(this.dishes[this.cur]);
      }
      this.render();
      this.kick();
    }

    /* ---------- layout ---------- */
    layout() {
      const W = this.stage.clientWidth, H = this.stage.clientHeight;
      if (!W || !H) return;
      this.W = W; this.H = H;
      this.dpr = Math.min(window.devicePixelRatio || 1, 2);
      this.canvas.width = Math.round(W * this.dpr);
      this.canvas.height = Math.round(H * this.dpr);

      this.jh = H * 0.579;
      this.jw = this.jh * this.jarAspect;
      // Room inside the jar box for its shadow, so no browser clips it.
      this.jarPad = 18;
      if (this.jarEl) {
        this.jarEl.style.padding = this.jarPad + 'px';
        this.jarEl.style.width = this.jw + this.jarPad * 2 + 'px';
        this.jarEl.style.height = this.jh + this.jarPad * 2 + 'px';
      }
      this.dishes.forEach((d) => {
        const maxW = W * 0.8 * d.size, maxH = H * 0.4934 * d.size;
        d.w = Math.min(maxW, maxH * d.aspect);
        d.h = d.w / d.aspect;
        d.cx = W * 0.48;
        d.cy = H * 0.924 - d.h / 2;
        d.el.style.width = d.w + 'px';
        d.el.style.height = d.h + 'px';
      });
      this.slide = W * 0.98;
      this.render();
    }

    /* ---------- play state ---------- */
    setPlaying(on) {
      this.playing = !!on;
      this.kick();
    }

    setWord(name, instant) {
      const el = this.wordText;
      if (!el || !name) return;
      if (instant || this.reduced || !el.animate) {
        el.textContent = name;
        return;
      }
      const out = el.animate(
        [{ transform: 'translateY(0)', opacity: 1 }, { transform: 'translateY(-0.4em)', opacity: 0 }],
        { duration: 180, easing: 'cubic-bezier(.5,0,.75,0)', fill: 'forwards' }
      );
      out.onfinish = () => {
        el.textContent = name;
        el.animate(
          [{ transform: 'translateY(0.45em)', opacity: 0 }, { transform: 'translateY(0)', opacity: 1 }],
          { duration: 340, easing: 'cubic-bezier(.2,1.4,.4,1)', fill: 'forwards' }
        );
        if (this.squigglePath && this.squigglePath.animate) {
          this.squigglePath.animate(
            [{ strokeDashoffset: 1 }, { strokeDashoffset: 0 }],
            { duration: 520, delay: 120, easing: 'cubic-bezier(.3,.7,.3,1)', fill: 'backwards' }
          );
        }
      };
    }

    /* ---------- timeline ---------- */
    jump(i) {
      if (i === this.cur && this.prev === -1) return;
      if (i === this.cur && this.cycleT < this.period) {
        if (!this.playing) { this.cycleT = T.back1 + 0.1; this.prefill(this.dishes[i]); this.render(); }
        return;
      }
      this.queued = i;
      if (this.playing) {
        this.jarFrom = this.jarPose ? { ...this.jarPose } : null;
        this.jarBlend = this.jarFrom ? 0 : null;
        this.cycleT = this.period;
      } else {
        this.nextDish();
        this.prev = -1;
        this.cycleT = T.back1 + 0.1;
        this.jarBlend = null;
        this.particles.length = 0;
        this.prefill(this.dishes[this.cur]);
        this.render();
      }
    }

    nextDish() {
      if (this.prev >= 0 && this.prev !== this.cur) this.dishes[this.prev].stuck.length = 0;
      if (this.N === 1) {
        this.dishes[0].stuck.length = 0;
        this.prev = -1;
      } else {
        this.prev = this.cur;
        this.cur = this.queued != null ? this.queued : (this.cur + 1) % this.N;
        this.dishes[this.cur].stuck.length = 0;
      }
      this.queued = null;
      this.cycleT = 0;
      this.setWord(this.dishes[this.cur].name);
      this.load(this.dishes[(this.cur + 1) % this.N]);
    }

    /* Fetch a dish's image just before its turn (it waits in a <template> until then). */
    load(d) {
      if (!d || d.requested) return;
      d.requested = true;
      const t = d.el.querySelector('template');
      if (t) t.replaceWith(t.content.cloneNode(true));
      const img = d.el.querySelector('img');
      const done = () => { d.ready = true; this.loadMask(d); };
      if (!img) return done();
      const decode = () => (img.decode ? img.decode() : Promise.resolve()).then(done, done);
      if (img.complete && img.naturalWidth) decode();
      else { img.addEventListener('load', decode, { once: true }); img.addEventListener('error', done, { once: true }); }
    }

    advance(dt) {
      this.clock += dt;
      this.jarIntro += dt;
      if (this.jarBlend != null) {
        this.jarBlend += dt;
        if (this.jarBlend > 0.45) this.jarBlend = null;
      }
      const t0 = this.cycleT;
      const t1 = (this.cycleT += dt);

      // A burst leaves the holes at the hard stop of each flick.
      for (let k = 0; k < T.flicks; k++) {
        const te = T.tilt1 + k * T.flick + T.flick * 0.3;
        if (t0 < te && t1 >= te) this.burst(k);
      }
      if (t1 > T.tilt1 && t1 < T.shake1) {
        this.trickle += dt * 55 * this.density;
        while (this.trickle >= 1) { this.trickle -= 1; this.spawn(Math.random() < 0.45, 0.6); }
      }
      if (this.cycleT >= this.period) {
        // Hold the current dish (up to 2.5s) if the next image hasn't arrived yet.
        const next = this.dishes[this.queued != null ? this.queued : (this.cur + 1) % this.N];
        this.load(next);
        if (next.ready || this.N === 1 || (this.wait += dt) > 2.5) { this.wait = 0; this.nextDish(); }
      }
      this.step(dt);
    }

    jarTarget() {
      const W = this.W, H = this.H, u = this.cycleT, c = this.clock;
      const rest = {
        x: W * 0.81,
        y: H * 0.345 + Math.sin(c * 1.7) * H * 0.009,
        a: -9 + Math.sin(c * 1.25) * 1.8
      };
      const pour = { x: W * 0.78, y: H * 0.297, a: -122 };
      // Sweep the holes across this dish's seasoning area, right to left.
      const d = this.dishes[this.cur];
      let sweepTo = W * 0.58;
      if (d && d.w) {
        const fa = this.foodArea(d, { x: d.cx, y: d.cy });
        const reach = -Math.sin(pour.a * DEG) * this.jh * HOLES;
        pour.x = clamp(fa.x + fa.rx * 0.44 + reach, W * 0.4, W * 0.83);
        sweepTo = clamp(fa.x - fa.rx * 0.09 + reach, W * 0.35, pour.x);
      }
      let p;
      if (u < T.tilt0) p = rest;
      else if (u < T.tilt1) p = lerpPose(rest, pour, inOut((u - T.tilt0) / (T.tilt1 - T.tilt0)));
      else if (u < T.shake1) {
        const f = ((u - T.tilt1) / T.flick) % 1;
        const pulse = f < 0.3 ? Math.pow(f / 0.3, 2) : 1 - inOut((f - 0.3) / 0.7);
        const ax = Math.sin(pour.a * DEG), ay = -Math.cos(pour.a * DEG);
        const off = pulse * H * 0.045;
        const sx = lerp(pour.x, sweepTo, inOut((u - T.tilt1) / (T.shake1 - T.tilt1)));
        p = { x: sx + ax * off, y: pour.y + ay * off, a: pour.a + Math.sin(f * TAU) * 3.5 };
      } else if (u < T.back1) p = lerpPose({ x: sweepTo, y: pour.y, a: pour.a }, rest, outBack((u - T.shake1) / T.back, 1.15));
      else p = rest;

      if (this.jarIntro < 0.9) {
        const k = outBack(clamp(this.jarIntro / 0.9, 0, 1), 1.2);
        p = { x: p.x, y: lerp(-H * 0.7, p.y, k), a: lerp(-28, p.a, k) };
      }
      if (this.jarBlend != null && this.jarFrom) p = lerpPose(this.jarFrom, p, inOut(clamp(this.jarBlend / 0.45, 0, 1)));
      return p;
    }

    holes(p) {
      const ax = Math.sin(p.a * DEG), ay = -Math.cos(p.a * DEG), d = this.jh * HOLES;
      return { x: p.x + ax * d, y: p.y + ay * d, ax, ay };
    }

    burst(k) {
      const n = Math.round((k === 0 ? 46 : 36) * this.density);
      for (let i = 0; i < n; i++) this.spawn(false, 1);
      const m = Math.round(28 * this.density);
      for (let i = 0; i < m; i++) this.spawn(true, 1);
    }

    spawn(dust, power) {
      if (!this.jarPose || this.particles.length > 900) return;
      const H = this.H, W = this.W, h = this.holes(this.jarPose);
      const px = -h.ay, py = h.ax; // across the lid
      const o = rand(-0.38, 0.38) * this.jw, along = rand(0, 0.03) * this.jh;
      const speed = rand(0.08, 0.62) * H * power, spread = rand(-0.24, 0.24) * H;
      const r = Math.random();
      if (!this.atlas) dust = true;
      this.particles.push({
        x: h.x + px * o + h.ax * along,
        y: h.y + py * o + h.ay * along,
        vx: h.ax * speed + px * spread + rand(-0.08, 0.6) * H * power,
        vy: h.ay * speed + py * spread - rand(0, 0.05) * H,
        rot: rand(0, TAU), vr: rand(-7, 7),
        flip: rand(0, TAU), vf: rand(3, 11),
        dust,
        size: dust ? W * rand(0.0032, 0.0062) : W * (0.009 + 0.017 * r * r),
        sprite: this.atlas ? Math.floor(Math.random() * this.atlas.count) : 0,
        color: DUST[Math.floor(Math.random() * DUST.length)],
        depth: rand(-0.9, 0.9)
      });
    }

    foodArea(d, box) {
      return {
        x: box.x + d.sx * d.w,
        y: box.y + (d.sy - 0.06) * d.h,
        rx: d.w * 0.47 * d.sw,
        ry: d.h * 0.29
      };
    }

    step(dt) {
      const H = this.H, g = H * 2.1;
      const d = this.dishes[this.cur];
      const landed = this.N === 1 || this.cycleT > T.enter * 0.95;
      const box = this.dishBox(d, true);
      const food = this.foodArea(d, box);
      const ps = this.particles;
      for (let i = ps.length - 1; i >= 0; i--) {
        const p = ps[i];
        const py = p.y;
        p.vy += g * dt;
        const drag = p.dust ? 0.5 : 1.3;
        p.vx *= 1 - drag * dt;
        p.vy *= 1 - drag * 0.35 * dt;
        p.x += p.vx * dt;
        p.y += p.vy * dt;
        p.rot += p.vr * dt;
        p.flip += p.vf * dt;
        if (landed) {
          const dx = (p.x - food.x) / food.rx;
          if (dx > -1 && dx < 1) {
            const landY = food.y + food.ry * Math.sqrt(1 - dx * dx) * p.depth;
            if (py < landY && p.y >= landY) {
              const onFood = this.solid(d, (p.x - box.x) / d.w, (landY - box.y) / d.h);
              if (!onFood) {
                // Nothing to land on here: let it fall a little further and try again.
                if (p.depth < 0.9) p.depth = Math.min(0.95, p.depth + rand(0.15, 0.5));
              } else if (Math.random() < 0.9) {
                if (d.stuck.length > 340) d.stuck.shift();
                d.stuck.push({
                  u: (p.x - box.x) / d.w, v: (landY - box.y) / d.h,
                  s: p.size / this.W, rot: p.rot - box.rot * DEG,
                  fx: Math.max(0.5, Math.abs(Math.cos(p.flip))),
                  dust: p.dust, sprite: p.sprite, color: p.color
                });
                ps.splice(i, 1);
                continue;
              }
            }
          }
        }
        if (p.y > H * 1.05 || p.x < -40 || p.x > this.W + 40) ps.splice(i, 1);
      }
    }

    /* Position, lean, squash and opacity of a dish at the current moment.
       Leaving: a small wind-up to the right, then it whips out to the left.
       Arriving: it hops in from the right, overshoots, lands with a squash and wobbles. */
    dishBox(d, current) {
      const H = this.H, u = this.cycleT;
      if (this.N === 1) return { x: d.cx, y: d.cy, rot: 0, alpha: 1, sx: 1, sy: 1, lift: 0 };
      if (current) {
        const t = clamp((u - T.enterDelay) / T.enterDur, 0, 1);
        const k = outBack(t, 1.45);
        const lift = Math.sin(Math.PI * t) * H * 0.055;
        let rot = -8 * Math.sin(Math.PI * t);
        let sx = 1, sy = 1;
        const tau = u - T.enter;
        if (tau > 0) {
          const e = Math.exp(-9 * tau), c = Math.cos(21 * tau);
          sy = 1 - 0.075 * e * c;
          sx = 1 + 0.05 * e * c;
          rot += 3.2 * e * Math.sin(18 * tau);
        }
        return { x: d.cx + this.slide * (1 - k), y: d.cy - lift + (1 - sy) * d.h / 2, rot, alpha: 1, sx, sy, lift };
      }
      const wf = Math.sin((Math.PI / 2) * clamp(u / T.windup, 0, 1));
      const t = clamp((u - T.windup) / (T.exit - T.windup), 0, 1);
      const k = inOut(t);
      const s = 1 - 0.12 * k;
      const lift = k * H * 0.04;
      const rot = -3.5 * wf * (1 - k) + 11 * k;
      return {
        x: d.cx + this.W * 0.035 * wf * (1 - k) - this.slide * 1.05 * k,
        y: d.cy - lift + (1 - s) * d.h / 2,
        rot, alpha: 1 - clamp((t - 0.6) / 0.4, 0, 1), sx: s, sy: s, lift
      };
    }

    loadMask(d) {
      if (d.mask !== undefined) return;
      d.mask = null;
      const img = d.el.querySelector('img');
      const src = d.el.dataset.mask || (img && (img.currentSrc || img.src));
      if (!src) return;
      const im = new Image();
      im.crossOrigin = 'anonymous';
      im.decoding = 'async';
      im.onload = () => {
        try {
          const w = 96, h = Math.max(1, Math.round(96 / d.aspect));
          const c = document.createElement('canvas');
          c.width = w; c.height = h;
          const x = c.getContext('2d', { willReadFrequently: true });
          x.drawImage(im, 0, 0, w, h);
          const px = x.getImageData(0, 0, w, h).data, a = new Uint8Array(w * h);
          for (let i = 0; i < a.length; i++) a[i] = px[i * 4 + 3];
          d.mask = { w, h, a };
        } catch (e) {
          d.mask = null; // image not readable (e.g. no CORS): fall back to the oval area
        }
      };
      im.src = src;
    }

    /* Is there food at this point? u, v are offsets from the dish centre in dish widths/heights. */
    solid(d, u, v) {
      const m = d.mask;
      if (!m) return true;
      const x = Math.floor((u + 0.5) * m.w), y = Math.floor((v + 0.5) * m.h);
      if (x < 0 || y < 0 || x >= m.w || y >= m.h) return false;
      return m.a[y * m.w + x] > 140;
    }

    prefill(d) {
      if (!d || !d.w) return;
      d.stuck.length = 0;
      const box = { x: d.cx, y: d.cy, rot: 0 };
      const food = this.foodArea(d, box);
      const n = Math.round(190 * this.density);
      for (let i = 0, tries = 0; i < n && tries < n * 6; tries++) {
        const a = Math.random() * TAU, r = Math.sqrt(Math.random()) * 0.92;
        const x = food.x + Math.cos(a) * r * food.rx, y = food.y + Math.sin(a) * r * food.ry;
        if (!this.solid(d, (x - box.x) / d.w, (y - box.y) / d.h)) continue;
        i++;
        const dust = !this.atlas || Math.random() < 0.4, rr = Math.random();
        d.stuck.push({
          u: (x - box.x) / d.w, v: (y - box.y) / d.h,
          s: dust ? rand(0.0032, 0.0062) : 0.009 + 0.017 * rr * rr,
          rot: rand(0, TAU), fx: rand(0.55, 1), dust,
          sprite: this.atlas ? Math.floor(Math.random() * this.atlas.count) : 0,
          color: DUST[Math.floor(Math.random() * DUST.length)]
        });
      }
    }

    /* ---------- drawing ---------- */
    drawFlake(f, x, y, size, rot, fx) {
      const ctx = this.ctx, dpr = this.dpr;
      if (f.dust) {
        ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
        ctx.fillStyle = f.color;
        ctx.fillRect(x - size / 2, y - size / 2, size, size * 0.85);
        return;
      }
      const a = this.atlas, c = Math.cos(rot), s = Math.sin(rot);
      ctx.setTransform(dpr * c * fx, dpr * s * fx, -dpr * s, dpr * c, dpr * x, dpr * y);
      const sx = (f.sprite % a.cols) * a.cell, sy = Math.floor(f.sprite / a.cols) * a.cell;
      ctx.drawImage(a.img, sx, sy, a.cell, a.cell, -size / 2, -size / 2, size, size);
    }

    placeDish(d, box) {
      const el = d.el;
      if (!box) {
        if (d.shown) { el.style.visibility = 'hidden'; d.shown = false; }
        return;
      }
      if (!d.shown) { el.style.visibility = 'visible'; d.shown = true; }
      el.style.transform = `translate3d(${(box.x - d.w / 2).toFixed(2)}px,${(box.y - d.h / 2).toFixed(2)}px,0) rotate(${box.rot.toFixed(3)}deg) scale(${box.sx.toFixed(4)},${box.sy.toFixed(4)})`;
      el.style.opacity = box.alpha.toFixed(3);
      if (d.shadowEl) {
        // The shadow stays on the table and shrinks while the dish is in the air.
        const air = clamp(box.lift / (this.H * 0.06), 0, 1);
        d.shadowEl.style.transform = `translateY(${(box.lift / box.sy).toFixed(2)}px) scale(${(1 - 0.45 * air).toFixed(3)})`;
        d.shadowEl.style.opacity = (1 - 0.65 * air).toFixed(3);
      }
    }

    render() {
      if (!this.W || !this.ctx) return;
      const ctx = this.ctx, W = this.W;
      const boxes = this.dishes.map(() => null);
      boxes[this.cur] = this.dishBox(this.dishes[this.cur], true);
      if (this.prev >= 0 && this.prev !== this.cur && this.cycleT < T.exit) boxes[this.prev] = this.dishBox(this.dishes[this.prev], false);
      this.dishes.forEach((d, i) => this.placeDish(d, boxes[i]));

      this.jarPose = this.jarTarget();
      if (this.jarEl) {
        const p = this.jarPose;
        this.jarEl.style.transform = `translate3d(${(p.x - this.jw / 2 - this.jarPad).toFixed(2)}px,${(p.y - this.jh / 2 - this.jarPad).toFixed(2)}px,0) rotate(${p.a.toFixed(2)}deg)`;
      }

      ctx.setTransform(1, 0, 0, 1, 0, 0);
      ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);

      boxes.forEach((box, i) => {
        if (!box) return;
        const d = this.dishes[i];
        if (!d.stuck.length) return;
        ctx.globalAlpha = box.alpha;
        const c = Math.cos(box.rot * DEG), s = Math.sin(box.rot * DEG);
        const fs = (box.sx + box.sy) / 2;
        for (const f of d.stuck) {
          const lx = f.u * d.w * box.sx, ly = f.v * d.h * box.sy;
          this.drawFlake(f, box.x + lx * c - ly * s, box.y + lx * s + ly * c, f.s * W * fs, f.rot + box.rot * DEG, f.fx);
        }
      });
      ctx.globalAlpha = 1;
      for (const p of this.particles) {
        this.drawFlake(p, p.x, p.y, p.size, p.rot, 0.35 + 0.65 * Math.abs(Math.cos(p.flip)));
      }
      ctx.setTransform(1, 0, 0, 1, 0, 0);
    }

    /* ---------- loop ---------- */
    kick() {
      const run = this._live && this.playing && this.visible && !document.hidden;
      if (run && !this.raf) {
        this.last = performance.now();
        this.raf = requestAnimationFrame((t) => this.frame(t));
      }
    }

    frame(now) {
      this.raf = 0;
      if (!(this._live && this.playing && this.visible && !document.hidden)) return;
      const dt = Math.min(0.05, (now - this.last) / 1000);
      this.last = now;
      if (this.W) {
        this.advance(dt);
        this.render();
      }
      this.raf = requestAnimationFrame((t) => this.frame(t));
    }
  }

  window.customElements.define('jimmy-hero', JimmyHero);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jimmy-story"] && !Shopify.designMode) return;
  try {
    
/* Jimmy story: moves one jar between the resting spots ("slots") of each part as the page scrolls. */
(() => {
  if (window.customElements.get('jimmy-story')) return;

  const clamp = (v, a, b) => Math.min(b, Math.max(a, v));
  const lerp = (a, b, t) => a + (b - a) * t;
  const ease = (t) => t * t * (3 - 2 * t);

  class JimmyStory extends HTMLElement {
    connectedCallback() {
      this.traveler = this.querySelector('[data-jst-traveler]');
      this.slots = [...this.querySelectorAll('[data-jst-slot]')];
      // The slot where the lid comes off (only when the open jar and lid images are set).
      this.openAt = this.slots.findIndex((s) => s.hasAttribute('data-jst-open'));
      this.reveals = [...this.querySelectorAll('[data-jst-reveal]')];
      // Without the animation every part keeps its own still jar.
      if (!this.traveler || this.slots.length < 2) return;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

      this.classList.add('is-live');
      this.tick = () => { this.raf = 0; this.update(); };
      this.onScroll = () => { if (!this.raf) this.raf = requestAnimationFrame(this.tick); };
      this.onResize = () => { this.measure(); this.onScroll(); };
      // Only listen to scrolling while the section is on screen.
      this.io = new IntersectionObserver(([entry]) => {
        window[entry.isIntersecting ? 'addEventListener' : 'removeEventListener']('scroll', this.onScroll, { passive: true });
        this.onScroll();
      });
      this.io.observe(this);
      // Images, fonts and window size all change where the slots are.
      this.ro = new ResizeObserver(this.onResize);
      this.ro.observe(this);
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScroll);
      cancelAnimationFrame(this.raf);
      this.io && this.io.disconnect();
      this.ro && this.ro.disconnect();
    }

    measure() {
      const host = this.getBoundingClientRect();
      this.poses = this.slots.map((slot) => {
        const r = slot.getBoundingClientRect();
        return {
          x: r.left - host.left + r.width / 2,
          y: r.top - host.top + r.height / 2,
          w: r.width,
          h: r.height,
          rot: parseFloat(getComputedStyle(slot).getPropertyValue('--rot')) || 0
        };
      });
      const first = this.poses[0];
      this.traveler.style.width = first.w + 'px';
      this.traveler.style.height = first.h + 'px';
    }

    update() {
      const p = this.poses;
      if (!p) return;
      const vh = window.innerHeight;
      // The point on the page level with the middle of the screen.
      const focus = vh * 0.5 - this.getBoundingClientRect().top;
      let i = 0;
      while (i < p.length - 2 && focus > p[i + 1].y) i++;
      const a = p[i], b = p[i + 1];
      // Rest at each slot for a while, then travel to the next one.
      const t = (focus - a.y) / (b.y - a.y);
      const k = ease(clamp((t - 0.2) / 0.6, 0, 1));
      const resting = t <= 0.2 ? i : t >= 0.8 ? i + 1 : -1;
      const open = this.openAt >= 0 && resting === this.openAt;
      if (open !== this.open) {
        this.open = open;
        this.classList.toggle('is-open', open);
        this.slots[this.openAt].closest('.jst__visual').classList.toggle('is-open', open);
      }
      const arc = Math.sin(Math.PI * k);
      const y = lerp(a.y, b.y, k);
      let x, scale = lerp(a.w, b.w, k) / p[0].w;
      if (this.clientWidth < 750) {
        // Stacked layout: swing out to the right edge and shrink a little, so it passes beside the text.
        x = lerp(lerp(a.x, b.x, k), this.clientWidth * 0.92, arc);
        scale *= 1 - 0.45 * arc;
      } else {
        // Side by side: cross over in the gap between the parts, not through the text.
        x = lerp(a.x, b.x, ease(clamp((k - 0.3) / 0.4, 0, 1)));
        scale *= 1 + 0.06 * arc;
      }
      const rot = lerp(a.rot, b.rot, k) + 16 * arc * (Math.sign(b.x - a.x) || 1);
      this.traveler.style.transform =
        `translate3d(${(x - p[0].w / 2).toFixed(1)}px,${(y - p[0].h / 2).toFixed(1)}px,0) rotate(${rot.toFixed(2)}deg) scale(${scale.toFixed(4)})`;
      for (const el of this.reveals) el.classList.toggle('is-in', el.getBoundingClientRect().top < vh * 0.6);
    }
  }

  window.customElements.define('jimmy-story', JimmyStory);
})();

  } catch(e) { console.error(e); }
})();
})();
